import Pagination from "../../components/pagination";
import {useRouter} from 'next/router';
import Page from "../../lib/page";
import MetaData, {Type} from "../../components/metadata";
import React from "react";
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {useTranslation} from 'next-i18next';
import Footer from "../../components/footer";
import Header from "../../components/header";
import SearchInput from "../../components/search/input";
import SearchButton from "../../components/search/button";
//import Button from "../../components/button";
import Info from "../../components/alert/info";
import Sort from "../../components/form/sort";
import IngredientList from "../../components/ingredientList";
import IngredientAPI from "../../lib/api/ingredient";

/**
 *
 * @type {number}
 */
const itemsPerPage = 25;

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Search(props) {
    // init
    const router = useRouter();
    const { t } = useTranslation();

    /**
     *
     * @param event
     */
    // function callback(event) {
    //     return new Promise(async resolve => {
    //         const form = event.target.closest('form');
    //         setTimeout(
    //             resolve,
    //             10000
    //         );
    //         event.preventDefault();
    //         form.submit();
    //     });
    // }

    // render
    return (
        <>
            {/* Metadata */}
            <MetaData
                type={Type.Website}
                title={t('ingredient.list')}
                description={t('ingredient.list.lead', { ns: 'glossary' })}
                keywords={[t('ingredient.list')]}
                imageURL={process.env.logoURL}
                urlOnlyForThisCountry={false}
                canonical={true}
            />

            {/* Header */}
            <Header />

            {/* Title */}
            <h1 className="text-center text-xxl-start fw-bold p-3 pb-0 pt-4 ps-xxl-5 ms-xxl-5">{t('ingredient.list')}</h1>

            {/* Form */}
            <nav className="navbar-light">
                <form id="searchForm" className="container p-3 ps-xxl-5 pe-xxl-5 ms-xxl-5 me-xxl-5 pt-4" autoComplete="off" method="GET" action={'/' + props.locale + '/ingredient/search'}>
                    {/* Search & Toogler */}
                    <div className="row">

                        {/* Search */}
                        <div className="position-relative col-7 col-sm-8 col-md-7 col-lg-8 pe-0 pe-lg-2">
                            <SearchInput type={'ingredient'} loadOnChoose={true} defaultValue={router.query.query ?? ''} multiple={false} name={'query'} required={false} placeholder={t('searchterm')} />
                        </div>
                        <div className="col-2 col-sm-2 col-md-3 col-lg-2 ps-0 ps-lg-2">
                            <SearchButton id={'search-ingredient-submit-btn'} />
                        </div>

                        {/* Toggler */}
                        <div className="col-3 col-sm-2 col-md-2 col-lg-2">
                            <button className="navbar-toggler filterToggler w-100" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#ingredientFilter" aria-controls="ingredientFilter" aria-expanded="false"
                                    aria-label="Toggle navigation">
                                <span className="d-none d-lg-inline me-lg-2 small">{'Filter'}</span>
                                <span className="navbar-toggler-icon" />
                            </button>
                        </div>
                    </div>

                    {/* Filter */}
                    <div className="row collapse navbar-collapse" id="ingredientFilter">

                        {/* Sorting */}
                        <div className="dropdown col-12 col-sm-6 col-lg-4 mt-3">
                            <Sort defaultValue={router.query.sort ?? ''} />
                        </div>

                        {/* Label */}
                        <div className="col-12 col-sm-6 col-lg-4 mt-3">
                            <SearchInput type={'ingredient-type'} loadOnChoose={false} defaultValue={router.query.type ?? ''} multiple={false} name={'type'} required={false} placeholder={t('search.ingredient.type')} />
                        </div>

                        {/* Submit-Button */}
                        {/*<div className="col-12 col-sm-6 col-lg-4 mt-3">
                            <Button
                                outline={false}
                                color={'primary'}
                                text={t('display.results')}
                                callback={callback}
                                hideTextOnMobile={false}
                                submitOnlyOnce={false}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     className="buttonIcon bi bi-list-ul align-text-bottom" viewBox="0 0 16 16">
                                    <path fillRule="evenodd"
                                          d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                </svg>
                            </Button>
                        </div>*/}
                    </div>
                </form>
            </nav>

            {/* Badges for filter */}
            <div className={'container d-lg-none mb-4'}>
                {router.query.sort ? <span className="badge rounded-pill bg-secondary me-1">{t(router.query.sort)}</span> : ''}
                {router.query.allergen_free ? <span className="badge rounded-pill bg-secondary me-1">{t('allergen.free')}</span> : ''}
                {router.query.vegan ? <span className="badge rounded-pill bg-secondary me-1">{t('vegan')}</span> : ''}
                {router.query.vegetarian ? <span className="badge rounded-pill bg-secondary me-1">{t('vegetarian')}</span> : ''}
                {router.query.additive_free ? <span className="badge rounded-pill bg-secondary me-1">{t('additive.free')}</span> : ''}
            </div>

            {/* Ingredients */}
            <div className="container mt-3 pb-5 ps-xxl-5 pe-xxl-5 ms-xxl-5 me-xxl-5">

                {
                    props.ingredients.length
                        ?
                        <>
                            {/* Ingredient-List */}
                            <div className="container pb-4">
                                <IngredientList ingredients={props.ingredients} />
                            </div>

                            {/* Pagination */}
                            <Pagination
                                currentPage={props.pagination.page}
                                resultCount={props.pagination.results}
                                moreResults={props.pagination.moreResults}
                                entriesPerPage={itemsPerPage}
                            />
                        </>
                        :
                        <>
                            {/* Info-Message */}
                            <Info message={t('ingredient.not.found', {ns: 'glossary'})} />
                        </>
                }
            </div>

            {/* Footer */}
            <Footer />
        </>
    )
}

/**
 *
 * @param context
 * @returns {Promise<{props: {products: []}}>}
 */
export async function getServerSideProps(context) {
    // caching
    context.res.setHeader(
        'Cache-Control',
        'public, s-maxage=86400, stale-while-revalidate=3600'
    )

    // init the page
    let page = new Page;
    page.init(context.locale);

    let ingredientAPI = new IngredientAPI(
        page.language,
        page.country
    );

    // init pagination
    const pagination = {
        page: context.query.page ? parseInt(context.query.page) : 1,
        results: 0,
        moreResults: false
    };

    // get the data
    const data = await ingredientAPI.selectList(
        context.query.query ?? '',
        context.query.sort ?? 'relevance',
        context.query.type ?? '',
        pagination.page,
        itemsPerPage
    );

    // parse the result
    let ingredients = [];
    if(data && 'ok' === data.header.status && data.footer.results > 0) {
        ingredients = data.body.ingredients;

        // setup pagination
        pagination.results = data.footer.results;
        pagination.moreResults = data.footer.more_results;
    }

    // result
    return {
        props: {
            ...(await serverSideTranslations(context.locale, ['common', 'languages', 'countries', 'glossary', 'ingredients', 'ingredient-types'])),
            "ingredients": ingredients,
            "pagination": pagination,
            "locale": page.locale
        },
    }
}